<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wwEsC0/tc-custom/9781611216301.jpg?1733109323968" alt="This image is the cover for the book Civil War on the Water, Emerging Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Civil War on the Water, Emerging Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>The Civil War was primarily a land conflict, but it was not only that.  “Nor must Uncle Sam’s web-feet be forgotten,” wrote Abraham Lincoln. “At all the watery margins they have been present. Not only on the deep sea, the broad bay, and the rapid river, but also up the narrow, muddy bayou, and wherever the ground was a little damp, they have been and made their tracks.”  From the Arctic Circle to the Caribbean, swift Rebel raiders decimated Union commerce pursued by the U. S. Navy. Offshore, storm-tossed blockaders in hundreds of vessels patrolled from Hatteras to Galveston while occasionally lobbing a few shots at a speeding Rebel runner.  Around the continental periphery, it was ships vs. powerful fortifications as titanic clashes erupted: Port Royal, New Orleans, Charleston, Mobile. Massive army-navy amphibious operations presaged twentieth-century conflicts: The Peninsula, North Carolina Sounds, Fort Fisher. In the heartland, the two services invented riverine warfare: Forts Henry and Donelson, Island No. 10, Memphis, Vicksburg.  And through it all, emerging technology of the machine age played a critical role: iron armor, torpedoes, steam propulsion, heavy naval artillery.  However, nothing in the history and traditions of the United States Navy had prepared it for civil war. The sea service would expand tenfold from a third-rate force to (temporarily) one of the most powerful and advanced navies. Meanwhile, former shipmates in the Confederacy struggled to construct a fleet from nothing, applying innovative technologies and underdog strategies to achieve more than anyone thought possible.  Both sides faced unprecedented strategic, tactical, and technological challenges that made their navies indispensable—even as the navies themselves faced those same sorts of challenges.  The Civil War on the Water: Favorite Stories and Fresh Perspectives from the Historians at Emerging Civil War compiles favorite navy tales and obscure narratives by distinguished public historians of the Emerging Civil War in celebration of the organization’s tenth anniversary. This eclectic collection presents new stories and familiar battles from a unique perspective—from the water—sea, surf, and stream.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dwight Sturtevant Hughes, Chris Mackowski
      </h2>
      
      <p class="authorDescription body article">Dwight Hughes is a public historian, author, and speaker in Civil War naval history. Lt. Cmdr. Hughes graduated from the U.S. Naval Academy in 1967 and served 20 years aboard warships, on navy staffs, and with river forces in Vietnam. He is the author of Unlike Anything That Ever Floated: The Monitor and Virginia and the Battle of Hampton Roads, March 8–9, 1862 (Savas Beatie, 2021) and a contributing author at the Emerging Civil War blog.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8eb4368c